module.exports = __webpack_public_path__ + "img/3.ac12d538.png";